/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Center_Left_TitleInputs */



/**
* | output |
* | --- |
* | "Position: Center Left" |
*
* @param {Position_Center_Left_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_center_left_title = /** @type {((inputs?: Position_Center_Left_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Center_Left_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Position : Au Centre a Gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position: Mitte links")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione: Centro-sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция: Левый центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición: Centro Izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置：左中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ポジション: 中央左")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति: केंद्र बाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição: Centro Esquerdo")
	return /** @type {LocalizedString} */ ("Position: Center Left")
});